import React, { useState } from 'react';

const DigitalFarming = () => {
  const [showExpanded, setShowExpanded] = useState(false);

  const toggleExpanded = () => setShowExpanded(!showExpanded);

  return (
    <section className="px-4 md:py-[20px] py-4 md:px-24 bg-white">
      <div className="md:text-left md:mb-3 mb-1">
        <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[40px] md:mt-5 tracking-wide">DIGITAL FARMING</h1>
        <h2 className="text-black text-[12px] md:text-[40px] md:mt-2 md:hidden flex font-bold">Lets Go Namibia!</h2>
        <h2 className="text-black text-[12px] md:text-[40px] md:flex hidden tracking-wide font-bold">Lets Go Namibia!</h2>
      </div>

      <div className="flex md:flex-row md:items-start gap-1 md:gap-4">
        {/* Image */}
        <div className="w-[200px] md:w-1/2 rounded-xl">
          <a href='/news'>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749482747/image_5_rixrlu.png"
              alt="Digital Farming"
              className="md:w-full md:flex hidden md:h-auto object-contain rounded-xl"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749482747/image_5_rixrlu.png"
              alt="Digital Farming"
              className="w-[250px] md:hidden flex h-[100px] object-contain rounded-md"
            />
          </a>
        </div>

        {/* Text */}
        <div className="w-[250px] md:w-[550px] relative">
          <h1 className="text-black font-bold text-[10px] md:text-[44px]" style={{ lineHeight: '1.10' }}>
            Have you registered as a Farmer?
          </h1>

          {/* Default Paragraph */}
          {!showExpanded && (
            <div className="transition-opacity duration-300 ease-in-out opacity-100 mt-1 md:mt-3">
              <p className="text-black md:text-[30px] text-[8px] leading-7" style={{ lineHeight: '1.15' }}>
                Why Register as a Farmer? <br />
                Farmnet is a dynamic network built for African farmers - connecting you to national, continental, and global markets.
                Are you a farmer? Then Farmnet is your gateway to.          visibility,   opportunity, and

              {/* Desktop Expand Icon */}
              <div className="md:flex hidden items-center justify-between space-x-4 text-[30px]">
              growth...
                <button onClick={toggleExpanded}>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748784629/Expand_right_1_oh82zp.png"
                    alt="Expand"
                    className={`w-[34px] h-[34px] transition-transform duration-300 ${showExpanded ? 'rotate-90' : 'rotate-0'}`}
                  />
                </button>
              </div>
              </p>


              {/* Mobile See More */}
              <div className="flex md:hidden justify-end items-center space-x-2 mt-2 text-[10px]">
                <button onClick={toggleExpanded} className="flex items-center">
                  <p className="bg-[#2E453D] text-white px-2 py-[3px] text-[8px] rounded-bl-lg rounded-tl-lg font-bold">
                    See more
                  </p>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                    alt="Expand"
                    className={`h-[18px] w-4 object-contain rounded-tr-lg rounded-br-lg bg-[#152C24] px-1 transition-transform duration-300 ${showExpanded ? 'rotate-90' : 'rotate-0'}`}
                  />
                </button>
              </div>
            </div>
          )}

          {/* Expanded Paragraph */}
          <div className={`transition-all duration-500 ease-in-out ${showExpanded ? 'opacity-100 mt-4 max-h-[2000px]' : 'opacity-0 max-h-0 overflow-hidden'}`}>
            <h2 className="text-black font-bold text-[16px] md:text-[30px] mb-2">Why Register as a Farmer?</h2>
            <p className="text-black text-[12px] md:text-[30px] space-y-2 font-medium">
              Farmnet is a dynamic network built for African farmers — connecting you to national, continental, and global markets.
              Are you a farmer? Then Farmnet is your gateway to visibility, opportunity, and growth.
              <br />
              <br />
              By registering with Farmnet, you make it easier for off-takers, contractors, traders, financiers, government agencies, service providers, donors, manufacturers, importers, exporters, and regulators to find and engage with you.
              <br />
              Let the world know:
              <ul className="list-disc list-inside leading-[1.20] mt-2">
                <li>Who you are</li>
                <li>Where you are located</li>
                <li>What you produce</li>
                <li>When and how you produce it</li>
                <li>How much you produce</li>
              </ul>
              <br />
              When you're visible, opportunities come to you. Farmnet helps you maximize your reach and profits by putting your farm on the map — literally and commercially.
              <br />
              <span className="font-bold underline">Register today and let the markets come to you.</span>
            </p>
          </div>
          {showExpanded && (
  <div className="flex justify-end mt-4">
    <button onClick={toggleExpanded} className="flex items-center">
    <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748784629/Expand_right_1_oh82zp.png"
                    alt="Expand"
                    className={`w-[34px] h-[34px] transition-transform duration-300 ${showExpanded ? '-rotate-90' : 'rotate-0'}`}
                  />
                  </button>
  </div>
)}

        </div>
      </div>
    </section>
  );
};

export default DigitalFarming;
